<div>
  <app-loading-spinner *ngIf="!refDetails && !apiError"></app-loading-spinner>
  <app-api-error-display *ngIf="apiError" [error]="apiError"></app-api-error-display>

<div id="reference-details" class="details-page" *ngIf="refDetails && !apiError">
  <app-social-contact></app-social-contact>

  <div class="details-page-name-and-id">
    <span *ngIf="isPubMedRef" class="details-page-name-and-id-prefix">Publication:</span>
    <span *ngIf="!isPubMedRef" class="details-page-name-and-id-prefix">Reference:</span>
    <span class="reference-title name-id-highlight" *ngIf="refDetails.title">
      {{refDetails.title}}
    </span>
  </div>

  <div id="reference-summary" class="details-page-summary">
    <ng-container *ngIf="refDetails.authors">
      <div class="details-label">Authors</div>
      <div>{{refDetails.authors}}</div>
    </ng-container>

    <ng-container *ngIf="isPubMedRef">

      <ng-container *ngIf="!multiOrgMode && hasApprovedSession()">
        <div class="curation-status details-label">
          <a href="http://curation.pombase.org/pombe/"><img src="/assets/canto_icon.png"/></a>
        </div>

        <div class="curation-status curation-status-text">
            <div class="ref-curated-by" *ngIf="communityCuratorNames">
              Community curation provided by {{communityCuratorNames}}
            </div>
          <div *ngFor="let curator of adminCuratorList">
            <div class="ref-curated-by">
              Curation by {{curator.name}}
            </div>
          </div>
          <div class="ref-curated-by" *ngIf="!hasCommunityCurator() && hasAdminCurator() && !this.appConfig.show_names_of_staff_curators">
            Curated by {{siteName}} staff
          </div>
          <div class="ref-curated-by" *ngIf="communityFileCuratorNames">
            High-throughput dataset provided by {{communityFileCuratorNames}}
          </div>
          <div *ngIf="hasApprovedSession()">
            Added to {{siteName}} on <span class="approved-date">{{refDetails.approved_date}}</span>
          </div>
        </div>
      </ng-container>

      <div class="details-label">Citation</div>
      <div>{{refDetails.citation}}</div>
    </ng-container>

    <div class="details-label">ID</div>
    <div>{{refDetails.uniquename}}</div>

    <ng-container *ngIf="isPubMedRef">
      <div class="details-label">Links</div>
      <div>
        <a class="pub-link" href="http://europepmc.org/abstract/MED/{{pubMedId}}">Europe PMC</a>
          |
        <a class="pub-link" href="https://www.ncbi.nlm.nih.gov/pubmed?term={{pubMedId}}">PubMed</a>
        <span class="ref-doi" *ngIf="refDetails.doi">| DOI: <a href="{{doiUrl}}">{{refDetails.doi}}</a></span>
      </div>
    </ng-container>

    <ng-container *ngIf="refDetails.abstract">
      <div class="details-label">Abstract</div>
      <div class="abstract">
        <ng-container *ngIf="graphicalAbstractImagePath && !showBigGraphicalAbstract">
        <div *ngIf="bigGraphicalAbstractImagePath" class="small-graphical-abstract">
          <a (click)="displayBigGraphicalAbstract()"
             [popover]="graphicalAbstractPopover"
             triggers="mouseenter:mouseleave"
             placement="top"
             container="body">
            <img src="{{graphicalAbstractImagePath}}"/>
            <div class="small-graphical-abstract-text">View larger graphic</div>
          </a>
        </div>
        <div class="small-graphical-abstract" *ngIf="!bigGraphicalAbstractImagePath">
          <img title="Graphic" src="{{graphicalAbstractImagePath}}"/>
        </div>
        </ng-container>

        <video *ngIf="videoPath" width="300" loop autoplay class="small-graphical-abstract">
          <source src="{{videoPath}}" type="video/mp4">
        </video>


        {{refDetails.abstract}}
      </div>

    </ng-container>
  </div>

  <div *ngIf="showBigGraphicalAbstract">
    <img class="big-graphical-abstract" src="{{bigGraphicalAbstractImagePath}}"/>
  </div>

<div *ngIf="refDetails.pdb_entries.length > 0" class="pdb-structure-view">
  <app-pdb-structure-viewer [displayName]="refDetails.title" [pdbEntries]="refDetails.pdb_entries" [pageType]="'reference'">
  </app-pdb-structure-viewer>
</div>

  <div id="reference-details-menu">
    <app-details-page-menu [title]="refDetails.uniquename"
                           [menuItems]="menuItems"></app-details-page-menu>
  </div>

  <div *ngIf="externalLinks && externalLinks.length > 0"
       class="details-page-external-links">
  <div>External link<span *ngIf="externalLinks.length > 1">s</span>:</div>
  <ul>
    <li *ngFor="let externalLink of externalLinks">
      <a href="{{externalLink.link}}">
        <span [innerHTML]="externalLink.text"></span>
      </a>
    </li>
  </ul>
  </div>

  <div *ngIf="hasGenes()" class="ref-genes-link">
    <a routerLink="/ref_genes/{{refDetails.uniquename}}"
       routerLinkActive="active">View {{geneCount()}} gene{{geneCount()>1?'s':''}} from this publication as a gene results table ...</a>
  </div>

  <div>
    <div class="annotations-section-header">
      <div *ngIf="isCuratable()">

        <div *ngIf="hasAnnotations()">

          <div *ngIf="hasApprovedSession()">
            <div *ngIf="refDetails.uniquename.startsWith('PMID:')">
              Annotations from this publication:
            </div>
            <div *ngIf="!refDetails.uniquename.startsWith('PMID:')">
              Annotations from this reference:
            </div>
          </div>

          <div *ngIf="hasCantoSession() && !hasApprovedSession()">
            <div *ngIf="isAdminSession()">
              This paper has partial curation that predates {{siteName}} and Canto,
              or is imported from a third party database.
              Please
              <app-contact-email [linkName]="'contact the curators'"
                                 [subject]="'Request to contribute annotations for ' + refDetails.uniquename"></app-contact-email>
              if you would like to contribute to its full curation.
            </div>
            <div *ngIf="!isAdminSession()">
              This publication is assigned to one of the authors for community curation.
            </div>
          </div>

          <div *ngIf="!hasCantoSession()">
            This paper has partial curation that predates {{siteName}} and Canto,
            or is imported from a third party database.
            Please
            <app-contact-email [linkName]="'contact the curators'"
                               [subject]="'Request to contribute annotations for ' + refDetails.uniquename"></app-contact-email>
            if you would like to contribute to its full curation.
          </div>

        </div>

        <div *ngIf="!hasAnnotations() && !hasBrowserTracks()">
          <div *ngIf="hasCantoSession()">
            <div *ngIf="hasApprovedSession()">
              This publication has no annotations in {{siteName}}
              because the data it contains either cannot be associated
              with individual genes, or cannot be represented by
              currently available annotation types.
            </div>
            <div *ngIf="!hasApprovedSession()">
              <div *ngIf="isAdminSession()">
                This publication has no annotations in {{siteName}} because it hasn't been curated yet.
                Please
                <app-contact-email [linkName]="'contact the curators'"
                                   [subject]="'Request to contribute annotations for ' + refDetails.uniquename"></app-contact-email>
                if you want to contribute annotations for this paper.
              </div>
              <div *ngIf="!isAdminSession()">
                This publication is assigned to one of the authors for community curation.
              </div>
            </div>
          </div>

          <div *ngIf="!hasCantoSession()">
            This publication has no annotations in {{siteName}}
            because it hasn't been curated yet.  Please
            <app-contact-email [linkName]="'contact the curators'"
                               [subject]="'Request to contribute annotations for ' + refDetails.uniquename"></app-contact-email>
            if you want to contribute annotations <span *ngIf="hasPossibleBrowserTracks()">or high throughput datasets</span> for this paper.
        </div>

      </div>
    </div>

    <div *ngIf="isPublication() && !isCuratable() && !hasAnnotations() && !hasBrowserTracks()">
        <span>
          This publication has no
          annotations in {{siteName}} because
        </span>
        <span *ngIf="cantoTriageStatus == 'Review or comment'">
        it is a review.
        </span>
        <span *ngIf="cantoTriageStatus == 'Method or reagent'">
        it is a methods paper.
        </span>
        <span *ngIf="cantoTriageStatus != 'Review or comment' && cantoTriageStatus != 'Method or reagent'">
        the data it contains either cannot be associated with
        individual genes, or cannot be represented by currently
        available annotation types.
        </span>
    </div>
  </div>

<div class="pubmed-keyword-genes"
     *ngIf="refDetails.pubmed_keyword_genes.length > 0 && !hasApprovedSession()">
  Genes from PubMed keywords:
  <span *ngFor="let gene of refDetails.pubmed_keyword_genes">
    <app-gene-link [long]="false" [gene]="gene"></app-gene-link>
  </span>
</div>



  <div>
    <span *ngFor="let annotationTypeName of annotationTypeNames">
      <app-quant-gene-ex-table id="{{annotationTypeName}}" *ngIf="annotationTypeName == 'quantitative_gene_expression'"
                               [hideColumns]="['reference']"
                               [annotationTable]="refDetails.cv_annotations[annotationTypeName]"></app-quant-gene-ex-table>

      <app-annotation-table  id="{{annotationTypeName}}"
                             *ngIf="annotationTypeName != 'quantitative_gene_expression'"
                            [scope]="'reference'"
                            [annotationTypeName]="annotationTypeName"
                            [hideColumns]="['reference', 'desc-rel', 'genotype_background', 'allele_promoters']"
                            [featureInFirstColumn]="true"
                            [annotationTable]="refDetails.cv_annotations[annotationTypeName]"></app-annotation-table>

    <app-interaction-annotation-table [annotationTypeName]="'physical_interactions'"
      *ngIf="annotationTypeName == 'physical_interactions' && refDetails.physical_interactions.length != 0"
      id="{{annotationTypeName}}" [hideColumns]="['reference']"
      [annotationTable]="refDetails.physical_interactions"></app-interaction-annotation-table>

    <app-genetic-interaction-annotation-table [annotationTypeName]="'genetic_interactions'"
      *ngIf="annotationTypeName == 'genetic_interactions' && refDetails.genetic_interactions.length != 0"
      id="{{annotationTypeName}}" [hideColumns]="['reference']"
      [annotationTable]="refDetails.genetic_interactions"></app-genetic-interaction-annotation-table>

    <app-ortholog-annotation-table [hideColumns]="['reference']"
      *ngIf="annotationTypeName == 'orthologs' && refDetails.ortholog_annotations.length != 0"
      id="{{annotationTypeName}}"
      [annotationTable]="refDetails.ortholog_annotations"></app-ortholog-annotation-table>

    <app-paralog-annotation-table
        *ngIf="annotationTypeName == 'paralogs' && refDetails.paralog_annotations.length != 0"
        id="{{annotationTypeName}}"
        [annotationTable]="refDetails.paralog_annotations"></app-paralog-annotation-table>
    </span>
  </div>

  <app-jbrowse-track-picker [identifier]="refDetails.uniquename" [identifierType]="'reference'">
  </app-jbrowse-track-picker>

</div>
</div>

<ng-template #graphicalAbstractPopover>
  Click to view larger graphic
</ng-template>
